import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  autherise: boolean;
  ssoenabled: boolean;
  facilityData: any
}

const initialState: InitialState = {
  autherise: false,
  ssoenabled: true,
  facilityData:{}
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setAutherise: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      autherise: action.payload,
    }),
    setSSOisEnable: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      ssoenabled: action.payload,
    }),
    setfacilityData: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      facilityData: action.payload,
    }),
  },
});

export const { setAutherise,setSSOisEnable, setfacilityData} = commonSlice.actions;

export default commonSlice.reducer;
